import { config } from "@/config";
import type { UploadedFileProperty } from "@/interfaces/estimation.interface";
import { Provider } from "@/providers/http.provider";

interface IUploadFileData {
  uploadId: string;
  uploadIndex: number;
  mime: string;
  originalFileName: string;
  storagePath: string;
}

class FileProvider extends Provider {
  constructor() {
    super({
      baseURL: `${config.baseAPIUrl}/rest/files/`,
    });
  }

  async uploadFile(
    file: File,
    uploadId: string,
    estimateId: string,
    postUploadCommand: string,
    tpa?: string,
    carrier?: string,
  ): Promise<UploadedFileProperty[]> {
    try {
      const formData = new FormData();
      formData.append("files", file);
      formData.append("estimateId", estimateId);
      formData.append("postUploadCommand", postUploadCommand);
      formData.append("uploadId", uploadId);

      if (tpa?.length) formData.append("tpa", tpa);
      if (carrier?.length) formData.append("carrier", carrier);

      const response = await this.post<{ success: boolean; data: UploadedFileProperty[] }>("upload", formData, {
        headers: {
          Authorization: `Bearer ${Provider.token}`,
          uid: Provider.uid,
          "lasso-token": localStorage.getItem("lassoToken") ?? Provider.token,
          "Content-Type": "text/html",
        },
      });

      if (!response.success) throw new Error("Unable to upload file");

      return response.data;
    } catch (error) {
      console.error("Upload failed:", error);
      throw new Error();
    }
  }

  async uploadValueAddFile(
    files: File[],
    organizationId: string,
    estimateId?: string,
  ): Promise<{ success: boolean; data: IUploadFileData[] }> {
    try {
      const formData = new FormData();

      // Append all files with the same field name 'files'
      files.forEach((file) => {
        formData.append("files", file);
      });

      // Append organization ID
      formData.append("organizationId", organizationId);

      // Append estimate ID if provided
      if (estimateId) {
        formData.append("estimateId", estimateId);
      }

      const response = await this.post<{ success: boolean; data: IUploadFileData[] }>("upload/value-add", formData, {
        headers: {
          Authorization: `Bearer ${Provider.token}`,
          uid: Provider.uid,
          "lasso-token": localStorage.getItem("lassoToken") ?? Provider.token,
          "Content-Type": "text/html",
        },
      });

      if (!response.success) throw new Error("Unable to upload value-add files");

      return response;
    } catch (error) {
      console.error("Value-add upload failed:", error);
      throw new Error("Value-add upload failed");
    }
  }
}

export default new FileProvider();
